import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

// Store
import { saturnoStore } from '@Store/saturno';

// Hook
import { valPackage } from '@Hooks/useValidatePlanet';

// Styles
import style from '@Components/Planets/planets.module.scss';
import lines from '@Components/Planets/lines.module.scss';
import buttons from '@Sass/components/buttons.module.scss';

// Images
import _tank from '@Assets/images/tanque.png';
import _lock from '@Assets/images/lock.png';
import saturno from '@Assets/images/planets/saturno.svg';

export const Saturno = ({ saturnoInfo }) => {
  const [skills, setSkills] = useState([
    {
      skill: '',
    },
    {
      skill: '',
    },
    {
      skill: '',
    },
  ]);
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('SATURNO');
  const { getSaturno, dataSaturno } = saturnoStore(
    (state) => ({
      getSaturno: state.getSaturno,
      dataSaturno: state.dataSaturno,
    }),
    shallow
  );

  const { validateProject } = valPackage();

  useEffect(() => {
    if (saturnoInfo.titulo) {
      setSkills(saturnoInfo.skills);
      setDescription(saturnoInfo.descripcion);
      setTitle(saturnoInfo.titulo);
    }
  }, [saturnoInfo]);

  return (
    <div>
      <div className={style.cardItem}>
        <div className={style.card_name_tankItem}>
          <h2>{title}</h2>
          <div className={style.card_tank_value}>
            <label>x1</label>
            <img src={_tank} alt="tank" />
          </div>
        </div>
        <div className={`${style.planetImage_content} ${lines.lines_saturno} `}>
          <div className={lines.lines_saturno_1}>
            <p>{skills[0].skill}</p>
          </div>
          <div className={lines.lines_saturno_2}>
            <p>{skills[1].skill}</p>
          </div>
          <div className={lines.lines_saturno_3}>
            <p>{skills[2].skill}</p>
          </div>
          {getSaturno().lockedPlanet === 'desbloqueado' ? (
            <></>
          ) : (
            <img src={_lock} alt="lock" className={style.imgLock} />
          )}
          <img src={saturno} alt="planet" className={`${style.planetImage} ${style.saturno}`} />
        </div>
        <div className={style.planetInfo}>
          <p>{description}</p>
        </div>

        <div className={style.planetButton_content}>
          {getSaturno().id ? (
            <button
              className={`${
                dataSaturno.complete === 1
                  ? buttons.buttonPlanetCompleted
                  : dataSaturno.complete === 2
                  ? buttons.buttonPlanetIncomplete
                  : dataSaturno.complete === 0
                  ? buttons.buttonPlanet
                  : buttons.buttonPlanet
              }`}
              onClick={() => validateProject('saturno', 1)}
            >
              {dataSaturno.label}
            </button>
          ) : (
            <button className={style.moon_launchBtn} onClick={() => validateProject('saturno', 1)}>
              ACCEDER
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
